<template>
  <div :id="blockId" :style="blockStyle" class="element-editor emoji-editor">
    <svg width="100%" viewBox="0 0 40 40" :class="animateClass">
      <text
        x="5%"
        y="85%"
        textLength="100%"
      >{{ emoji.native }}</text>
    </svg>
  </div>
</template>

<script>
import utils from '@/util'

export default {
  name: 'EmojiBlock',
  props: {
    emoji: {
      type: Object,
      default: null,
    },
    blockId: {
      type: String,
      default: null,
    },
    blockStyle: {
      type: Object,
      default: null,
    },
    animation: {
      type: String,
      default: null,
    },
    isInfinity: {
      type: Boolean,
      default: false,
    },
    duration: {
      type: Number,
      default: 1,
    },

  },
  computed: {
    animateClass() {
      return utils.animateClass({
        animation: this.animation,
        isInfinity: this.isInfinity,
        duration: this.duration,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.emoji-content {
  font-size: 10vw;
  height: 100%;
}
</style>
